import { Controller } from "@hotwired/stimulus"

// Keeps a filter chip showing what is actually selected. The results come back in a Turbo
// frame, so the chip itself is never re-rendered by the server.
export default class extends Controller {
  static targets = ["text"]
  static values = { label: String }

  sync(event) {
    const select = event.target
    const chosen = select.value !== ""
    this.textTarget.textContent = chosen ? select.options[select.selectedIndex].text : this.labelValue
    this.element.classList.toggle("is-set", chosen)
  }
}
